import React from 'react';
import PropTypes from 'prop-types';

import IconLoading from '../icon/loading';
import Label from '../label'
import Icon from '../icon/icons/icon';
import * as models from '../icon/icons';

import './button-async.styl'
class ButtonAsync extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        icon: PropTypes.string,
        label: PropTypes.string,
        disabled:  PropTypes.bool,
        onClick: PropTypes.func.isRequired
    }

    state = {
        loading: false
    }

    onClick(e) {
        e.preventDefault();
        const { loading=false, printErr=false } = this.state;
        if(loading || printErr || this.props.disabled) return

        this.setState({loading: true});

        setTimeout(()=> {
            const promise = this.props.onClick()
            promise && promise.then(
                () => this.setState({loading: false, printErr: false}),
                () => this.setState({loading: false, printErr: true})
            ).then(() => setTimeout(() => this.setState({printErr: false}), 5000))
        }, 20);
    }

    render() {
        let {icon=false, className=false} = this.props;
        const {label=false, disabled=false, children=false} = this.props;
        const {loading=false, printErr=false} = this.state;
        const labelError = (icon || label) ? (icon || label) + '.error' : 'error'

        icon = models[icon || 'circleRight'];
        className = className ? ' ' + className : ''
        className = printErr ? ' error' : ''

        return <div className={"button button-async" + className + (disabled ? " disabled" : "")} onClick={this.onClick.bind(this)} disabled={disabled}>
            {loading ? <IconLoading type="bars" /> : ''}
            {!loading && icon ? <Icon svg={icon} /> : ''}
            {printErr ? <Label>{labelError}</Label> : ''}
            {!printErr && label ? <Label>{label}</Label> : ''}
            {children ? children : ''}
        </div>
    }
}

export default ButtonAsync;
